import * as R from "ramda";

import ARG from "./ARG.json";
import CHL from "./CHL.json";
import ECU from "./ECU.json";
import PRI from "./PRI.json";
import URY from "./URY.json";
import MEX from "./MEX.json";
import ESP from "./ESP.json";
import PER from "./PER.json";
import VEN from "./VEN.json";
import COL from "./COL.json";
import BRA from "./BRA.json";
import USA from "./USA.json";
import GTM from "./GTM.json";
import SLV from "./SLV.json";
import DOM from "./DOM.json";
import BOL from "./BOL.json";
// import FRA from "./FRA.json";

// These languages must have full (complete) JSON files
const defaults = {
  es: MEX,
  pt: BRA,
  en: USA
  // fr: FRA
};

const regionalizations = {
  MEX,
  BRA,
  USA,
  // FRA,
  // Regionalized languages based on default languages
  // (these can be incomplete JSON files)
  ARG: R.mergeDeepRight(defaults.es, ARG),
  CHL: R.mergeDeepRight(defaults.es, CHL),
  ESP: R.mergeDeepRight(defaults.es, ESP),
  PER: R.mergeDeepRight(defaults.es, PER),
  VEN: R.mergeDeepRight(defaults.es, VEN),
  COL: R.mergeDeepRight(defaults.es, COL),
  ECU: R.mergeDeepRight(defaults.es, ECU),
  URY: R.mergeDeepRight(defaults.es, URY),
  PRI: R.mergeDeepRight(defaults.es, PRI),
  GTM: R.mergeDeepRight(defaults.es, GTM),
  SLV: R.mergeDeepRight(defaults.es, SLV),
  DOM: R.mergeDeepRight(defaults.es, DOM),
  BOL: R.mergeDeepRight(defaults.es, BOL)
};

export default {
  ...defaults,
  ...regionalizations,

  "es-mx": regionalizations.MEX,
  "es-ar": regionalizations.ARG,
  "es-cl": regionalizations.CHL,
  "es-es": regionalizations.ESP,
  "es-pe": regionalizations.PER,
  "es-ve": regionalizations.VEN,
  "es-co": regionalizations.COL,
  "es-ec": regionalizations.ECU,
  "es-uy": regionalizations.URY,
  "es-pr": regionalizations.PRI,
  "pt-br": regionalizations.BRA,
  "en-us": regionalizations.USA,
  "es-gt": regionalizations.GTM,
  "es-sv": regionalizations.SLV,
  "es-do": regionalizations.DOM,
  "es-bo": regionalizations.BOL
  // "fr-fr": regionalizations.FRA
};
